let obj = {};
obj.companyIdTypeOptions = [
    // {
    //     value: "01",
    //     name: "组织机构代码证",
    // },
    {
        value: "04",
        name: "统一社会信用代码"
    },
    // {
    //     value: "02",
    //     name: "税务登记证"
    // },
    // {
    //     value: "03",
    //     name: "其他",
    // },
]
obj.plansValues = [
    {
        name: '方案一',
        value: 'P04014D01',
        money1: '100万',
        money2: '30万',
        money3: '5万',
        money4: '1万'
    },
    {
        name: '方案二',
        value: 'P04014D02',
        money1: '300万',
        money2: '50万',
        money3: '10万',
        money4: '2万'
    },
    {
        name: '方案三',
        value: 'P04014D03',
        money1: '500万',
        money2: '50万',
        money3: '10万',
        money4: '2.5万'
    }
]
//企业类型
obj.industryType = [
    {
        name: '农业',
        value: '01',
    },
    {
        name: '家具制造业',
        value: '21',
    },
    {
        name: '医药制造业',
        value: '27',
    },
    {
        name: '化学纤维制造业',
        value: '28',
    },
    {
        name: '建筑安装业',
        value: '48',
    },
    {
        name: '体育',
        value: '91',
    },
    {
        name: '群众团体、社会团体和宗教组织',
        value: '96',
    }
]
export default { ...obj }